// extracted by mini-css-extract-plugin
module.exports = {"container":"DigitsInput_container__kKVLK"};